import React, { ReactNode } from 'react';
type ExternalLinkProps = {
  href: string;
  children: ReactNode;
  variant?: 'inline' | 'company';
  className?: string;
};
export function ExternalLink({
  href,
  children,
  variant = 'inline',
  className = ''
}: ExternalLinkProps) {
  return <a href={href} target="_blank" rel={variant === 'company' ? 'noopener noreferrer' : 'noopener'} className={`${variant === 'inline' ? 'inline-link' : ''} ${className}`.trim()} data-id="element-190" data-mp="nd4lo59suj75">
      {children}
    </a>;
}